<template>
    <section class="lets-talk">
        <div class="background bg-img" :style="{ backgroundImage: `url(${backgroundImage})` }">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-center">
                            <h1 class="text-h2-sans">{{ $t('Let\'s Talk About Your Project') }}</h1>
                            <h4 class="hZUCZe">{{ $t('Get in touch with us to start discussing your project ideas and requirements.') }}</h4>
                           <BuutonContact />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import banner2 from '@/assets/images/bg_about2.jpg'
import BuutonContact from '@/components/ButtonContact.vue'

export default {
    name: 'LetstalkComponent',
    components: {
        BuutonContact
    },
    data() {
        return {
            backgroundImage: banner2
        }
    }
}
</script>

<style scoped>
/* ======= LetsTalk style ======= */
.lets-talk {
    position: relative;
}

.background {
    padding: 120px 0;
    position: relative;
    background-size: cover;
    background-position: center;
}

.background::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
}

.text-center {
    position: relative;
    z-index: 2;
    color: #fff;
}

h2 {
    font-size: 3rem;
    margin-bottom: 20px;
    color: #fff;
}

p {
    font-size: 1.2rem;
    margin-bottom: 30px;
    color: #fff;
}

.btn-contact {
    display: inline-block;
    padding: 15px 40px;
    background: transparent;
    border: 2px solid #fff;
    color: #fff;
    text-decoration: none;
    border-radius: 30px;
    transition: all 0.3s ease;
}

.btn-contact:hover {
    background: #fff;
    color: #000;
}
</style>
